import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-0 bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
        <div className="flex-1 relative overflow-hidden bg-secondary-100/30">
          <img
            src="https://readdy.ai/api/search-image?query=Cozy%20reading%20atmosphere%20with%20warm%20lighting%2C%20person%20reading%20webtoon%20on%20tablet%2C%20comfortable%20modern%20interior%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20minimal%20lifestyle%20photography%2C%20clean%20composition%2C%20peaceful%20mood%2C%20high%20quality%2C%20natural%20light%20from%20window%2C%20plants%20decor&width=800&height=600&seq=cta-reading-scene&orientation=landscape"
            alt="阅读场景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
          <div className="relative z-10 p-8 md:p-12 flex flex-col justify-end h-full">
            <p className="text-xs tracking-widest text-background-50/70 mb-2 uppercase">READ ANYWHERE</p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight">
              随时随地
              <br />
              畅享阅读
            </h2>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-8 md:p-14 bg-background-50">
          <div className="max-w-md text-center">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 leading-tight">
              加入韩漫画网
              <br />
              发现精彩世界
            </h2>
            <p className="text-sm text-foreground-500 mt-4 leading-relaxed">
              每天都有新漫画上线，热门连载持续更新。无论你喜欢甜宠恋爱、热血战斗还是烧脑悬疑，这里都有属于你的故事。免费阅读，高清画质，快来开启你的漫画之旅吧！
            </p>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 mt-8 px-7 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              开始探索
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}